import ProhibitedCategoryRegister from '../../components/layout/ITHeadquarters/prohibitedCategoryRegister';

const ProhibitedCategoryRegisterPage = () => {
    return <ProhibitedCategoryRegister />;
};
export default ProhibitedCategoryRegisterPage;
